import { Icon } from '@iconify-icon/solid';
import {
  useSidebar,
} from "@/components/shadcn/sidebar"
import { Separator } from '@/components/shadcn/separator';
import { Button } from '@/components/shadcn/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuGroup,
  DropdownMenuItem,
} from "@/components/shadcn/dropdown-menu"
import { HeaderSearch } from './header/search';
import { UserMenu } from './user-menu';
import { ModeToggle } from '@/components/ui/mode-toggle';
import { useApplication } from '@/context/app';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbSeparator } from '@/components/shadcn/breadcrumb';
import { Show } from 'solid-js';
import { Card, CardContent } from "@/components/shadcn/card";

export const AppHeader = (props) => {

  const { getBreadcrumb } = useApplication();
  const { isMobile, toggleSidebar } = useSidebar();

  return (
    <>
      <header class="flex h-14 items-center gap-4 px-4 py-3 lg:h-[60px] lg:px-6 bg-sidebar border-b border-zinc-200 dark:border-zinc-800">
        <div class="flex flex-1 items-center">
          <Show when={isMobile()}>
            <Button
              onClick={() => toggleSidebar()}
              variant="outline"
              size="icon"
              class='bg-white dark:bg-black me-2 flex items-center justify-center'>
              <Icon icon="mingcute:menu-line" />
            </Button>
          </Show>
          <Show when={!isMobile()}>
            <Breadcrumb>
              <BreadcrumbList>
                <For each={getBreadcrumb()}>{(breadcrumb) =>
                  <BreadcrumbItem>
                    <Show when={breadcrumb.link}>
                      <BreadcrumbLink href={breadcrumb.link}>{breadcrumb.name}</BreadcrumbLink>
                      <BreadcrumbSeparator />
                    </Show>
                    <Show when={breadcrumb.current}>
                      <BreadcrumbLink current>{breadcrumb.name}</BreadcrumbLink>
                    </Show>
                  </BreadcrumbItem>
                }</For>
              </BreadcrumbList>
            </Breadcrumb>
          </Show>
        </div>
        <div class="ml-auto w-full flex flex-1 justify-end">
          <Show when={!isMobile()}>
            <HeaderSearch loading={props.loading} />
          </Show>
          <Show when={props.user.role === 'admin' || props.user.role === 'super'}>
          <DropdownMenu>
            <DropdownMenuTrigger as={props => <Button variant="outline" size="icon" class='bg-white dark:bg-black me-2 flex items-center justify-center' {...props} />}>
              <Icon icon="lets-icons:user-fill" />
              <span class="sr-only">Toggle staff menu</span>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuGroup>
                <DropdownMenuItem as={innerProps => <a href="/doctors" {...innerProps} />}>
                  <Icon icon="healthicons:doctor-24px" />
                  Doctors
                </DropdownMenuItem>
                <DropdownMenuItem as={innerProps => <a href="/receptionists" {...innerProps} />}>
                  <Icon icon="lets-icons:user-box" />
                  Receptionists
                </DropdownMenuItem>
                <DropdownMenuItem as={innerProps => <a href="/administrators" {...innerProps} />}>
                  <Icon icon="ri:shield-user-line" />
                  Administrators
                </DropdownMenuItem>
              </DropdownMenuGroup>
            </DropdownMenuContent>
          </DropdownMenu>
          <DropdownMenu>
            <DropdownMenuTrigger as={props => <Button variant="outline" size="icon" class='bg-white dark:bg-black me-2 flex items-center justify-center' {...props} />}>
              <Icon icon="bx:building-house" />
              <span class="sr-only">Toggle clinic menu</span>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuGroup>
                <DropdownMenuItem as={innerProps => <a href="/rooms" {...innerProps} />}>
                  <Icon icon="carbon:cabin-care-alert" />
                  Rooms
                </DropdownMenuItem>
                <DropdownMenuItem as={innerProps => <a href="/duties" {...innerProps} />}>
                  <Icon icon="uil:schedule" />
                  Duties
                </DropdownMenuItem>
              </DropdownMenuGroup>
            </DropdownMenuContent>
          </DropdownMenu>
          </Show>
          <ModeToggle />
          <DropdownMenu>
            <DropdownMenuTrigger as={props => <Button variant="outline" size="icon" class='bg-white dark:bg-black me-2 flex items-center justify-center' {...props} />}>
              <Icon icon="lucide:circle-user" />
              <span class="sr-only">Toggle user menu</span>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <UserMenu user={props.user} />
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </header>
      <Show when={isMobile()}>
        <div class="p-2 px-4">
          <Card class="rounded-md shadow-sm">
            <CardContent class="p-2 px-4">
              <Breadcrumb>
                <BreadcrumbList>
                  <For each={getBreadcrumb()}>{(breadcrumb) =>
                    <BreadcrumbItem>
                      <Show when={breadcrumb.link}>
                        <BreadcrumbLink href={breadcrumb.link}>{breadcrumb.name}</BreadcrumbLink>
                        <BreadcrumbSeparator />
                      </Show>
                      <Show when={breadcrumb.current}>
                        <BreadcrumbLink current>{breadcrumb.name}</BreadcrumbLink>
                      </Show>
                    </BreadcrumbItem>
                  }</For>
                </BreadcrumbList>
              </Breadcrumb>
            </CardContent>
          </Card>
        </div>
      </Show>
    </>
  );
}
